var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconTimeline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2C1.44772 2 1 2.44772 1 3V12C1 12.5523 1.44772 13 2 13H12C12.5523 13 13 12.5523 13 12V3C13 2.44772 12.5523 2 12 2H2ZM0 3C0 1.89543 0.89543 1 2 1H12C13.1046 1 14 1.89543 14 3V12C14 13.1046 13.1046 14 12 14H2C0.89543 14 0 13.1046 0 12V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 7C8.66421 7 9 6.66421 9 6.25C9 5.83579 8.66421 5.5 8.25 5.5C7.83579 5.5 7.5 5.83579 7.5 6.25C7.5 6.66421 7.83579 7 8.25 7Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 7C11.1642 7 11.5 6.66421 11.5 6.25C11.5 5.83579 11.1642 5.5 10.75 5.5C10.3358 5.5 10 5.83579 10 6.25C10 6.66421 10.3358 7 10.75 7Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 9.5C8.66421 9.5 9 9.16421 9 8.75C9 8.33579 8.66421 8 8.25 8C7.83579 8 7.5 8.33579 7.5 8.75C7.5 9.16421 7.83579 9.5 8.25 9.5Z",
    fill: "currentColor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.75 9.5C11.1642 9.5 11.5 9.16421 11.5 8.75C11.5 8.33579 11.1642 8 10.75 8C10.3358 8 10 8.33579 10 8.75C10 9.16421 10.3358 9.5 10.75 9.5Z",
    fill: "currentColor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 9.5C3.66421 9.5 4 9.16421 4 8.75C4 8.33579 3.66421 8 3.25 8C2.83579 8 2.5 8.33579 2.5 8.75C2.5 9.16421 2.83579 9.5 3.25 9.5Z",
    fill: "currentColor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 9.5C6.16421 9.5 6.5 9.16421 6.5 8.75C6.5 8.33579 6.16421 8 5.75 8C5.33579 8 5 8.33579 5 8.75C5 9.16421 5.33579 9.5 5.75 9.5Z",
    fill: "currentColor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3.25 12C3.66421 12 4 11.6642 4 11.25C4 10.8358 3.66421 10.5 3.25 10.5C2.83579 10.5 2.5 10.8358 2.5 11.25C2.5 11.6642 2.83579 12 3.25 12Z",
    fill: "currentColor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.75 12C6.16421 12 6.5 11.6642 6.5 11.25C6.5 10.8358 6.16421 10.5 5.75 10.5C5.33579 10.5 5 10.8358 5 11.25C5 11.6642 5.33579 12 5.75 12Z",
    fill: "currentColor"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M8.25 12C8.66421 12 9 11.6642 9 11.25C9 10.8358 8.66421 10.5 8.25 10.5C7.83579 10.5 7.5 10.8358 7.5 11.25C7.5 11.6642 7.83579 12 8.25 12Z",
    fill: "currentColor"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C3.27614 0 3.5 0.223858 3.5 0.5V1.5C3.5 1.77614 3.27614 2 3 2C2.72386 2 2.5 1.77614 2.5 1.5V0.5C2.5 0.223858 2.72386 0 3 0Z",
    fill: "currentColor"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 0C11.2761 0 11.5 0.223858 11.5 0.5V1.5C11.5 1.77614 11.2761 2 11 2C10.7239 2 10.5 1.77614 10.5 1.5V0.5C10.5 0.223858 10.7239 0 11 0Z",
    fill: "currentColor"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 3.5H13.5V4.5H0.5V3.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTimeline);
export default __webpack_public_path__ + "static/media/icon-timeline.3b463858ea046eadcc0bdbee35d9d900.svg";
export { ForwardRef as ReactComponent };